/**
 * 设备指纹哈希 → 64 位小写 hex。
 *
 * 后端 `DeviceFingerprintFilter` 只对认证路径校验 **格式** `^[0-9a-f]{64}$`
 * (不校验是否真实设备 / 不校验哈希值,见 story Dev Notes 调研§4)。
 *
 * 安全上下文(https / localhost)用 Web Crypto 出真实 SHA-256;
 * 极少数非安全上下文(无 crypto.subtle)走确定性回退,仍产出稳定的 64 位小写 hex
 * ——格式合法即可过滤器,且同设备稳定(deviceId 持久化)。
 */
export async function sha256Hex(input: string): Promise<string> {
  const subtle =
    typeof globalThis.crypto !== 'undefined' ? globalThis.crypto.subtle : undefined;
  if (subtle) {
    const data = new TextEncoder().encode(input);
    const digest = await subtle.digest('SHA-256', data);
    return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
  }
  return deterministicHex64(input);
}

/**
 * 确定性 64-hex 回退(非加密强度,仅在无 Web Crypto 时使用)。
 * 用 8 个不同种子的 32-bit FNV-1a 串接成 64 位 hex,保证同输入稳定、格式合法。
 */
function deterministicHex64(input: string): string {
  const seeds = [0x811c9dc5, 0x01000193, 0xdeadbeef, 0x12345678, 0xa5a5a5a5, 0x5f3759df, 0x9e3779b9, 0x7f4a7c15];
  let out = '';
  for (const seed of seeds) {
    let h = seed >>> 0;
    for (let i = 0; i < input.length; i++) {
      h ^= input.charCodeAt(i);
      h = Math.imul(h, 0x01000193) >>> 0;
    }
    out += h.toString(16).padStart(8, '0');
  }
  return out.slice(0, 64);
}
